














      
import Vue from 'vue'  
import Component from 'vue-class-component'  

@Component({
  name: 'QtyField', 
  props:{            
    value:{
      type:Number,
      default:0
    },           
    minValue:{
      type:Number,
      default:0
    },           
    maxValue:{
      type:Number,
      default:-1
    }
  }
})
export default class NumberFieldFactor extends Vue {  
      
  private value!:number  
  private minValue!:number      
  private maxValue!:number      
  private openQty = false    
  timeouID = -1

  startTimeout() {      
    if(this.timeouID>0) clearTimeout(this.timeouID)
    this.timeouID = setTimeout(()=> {
      this.openQty = false
      this.timeouID = -1
    },2000)
  }

  add() {
     if(this.maxValue == -1 || this.value < this.maxValue) this.$emit('input',this.value+1)       
  }
  remove() {
     if(this.value > this.minValue) this.$emit('input',this.value-1)       
  }    

  get disablePlus(){
    return this.maxValue >= 0 && this.value >= this.maxValue
  }

  get disableMoins(){
    return this.value <= this.minValue
  }
    
}
